module.exports = __webpack_public_path__ + "assets/img/b286a0db53271586ae977450db68050b.svg";